import { DateTime } from 'luxon';

export function toDateTime(value: string | Date | DateTime | undefined): DateTime | null {
  let date: DateTime | null = null;

  if (typeof value === 'string') {
    date = DateTime.fromISO(value);
  }

  if (value instanceof Date) {
    date = DateTime.fromJSDate(value);
  }

  if (value instanceof DateTime) {
    date = value;
  }

  return date;
}
